var jQuery = require('jquery');
import * as ko from 'knockout';

import './knockout/fileuploader.js';
import { addNotification } from './notifications';
import { uuidv4 } from './utils.js';

function UploadButton(data)
{
    var self = this;

    data = data || {};

    self.element_id         = data.element_id;
    self.entity_id          = data.entity_id;
    self.parent_id          = data.parent_id;
    self.entity_name        = data.entity_name;
    self.upload_type        = data.upload_type;
    self.acceptedFileTypes  = data.acceptedFileTypes;
    self.file_url           = data.file_url;
    self.file_second_url    = data.file_second_url;
    self.status             = data.status;
    self.task_log           = data.task_log;
    self.generate_parent_id = data.generate_parent_id;
    
    if( data.uploadKey )
        self.uploadKey          = data.uploadKey;
    else
        self.uploadKey          = ko.observable();

    self.upload_status      = ko.observable('init');
    self.transcode_progress = ko.observable();
    self.transcode_log      = ko.observable();
    self.uuid               = ko.observable(uuidv4());

    return self;
}

export { UploadButton };